
export default {
  name: 'ListingProductsListItemLabelPrimaryDealTag',
  props: {
    tag: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tags: [
        { key: 'daily_deal', class: this.$style.daily_deal_label, text: 'Daily <span>Deal</span>' },
        { key: 'clearance', class: this.$style.clearance_deal_label, text: 'Clearance' },
        { key: '1sb_choice', class: this.$style.one_sb_choice_label, text: 'Choice' },
        { key: '1sb_exclusive', class: this.$style.one_sb_exclusive_label, text: 'Exclusive' },
        { key: 'staff_pick', class: this.$style.staff_pick_label, text: 'Staff Pick' },
        { key: 'on_sale', class: this.$style.on_sale_label, text: 'On Sale' },
        { key: 'made_in_usa', class: this.$style.made_in_usa_label, text: 'Made in USA' },
        { key: 'best_seller', class: this.$style.best_seller_label, text: 'Best Seller' },
      ],
    };
  },
  computed: {
    currentTag() {
      return this.tags.find((tag) => tag.key === this.tag) || { key: '', class: '', text: this.tag };
    },
  },
};
